export const regexOnlyNumbers = /^[1-9]\d*$/;
export const regexAlphaNumeric = /^[a-zA-Z0-9]+$/;